/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:c98fec38-0f3e-400f-a264-c69a330a2668",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_D1PnECMcH",
    "aws_user_pools_web_client_id": "4sh6j2nkfclgfnq2b66gko5ma",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "shootingrecruitingaac79c26be894907b14800819147811534-production",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_content_delivery_bucket": "shootingrecruiting-20210517012459-hostingbucket-production",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://d2mravfub1xpj8.cloudfront.net"
};


export default awsmobile;
